module.exports = __webpack_public_path__ + "img/venus15.a24255b6.png";